module.exports = __webpack_public_path__ + "img/00022.2d8f5125.webp";